
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.53 5.53a.75.75 0 00-1.06-1.06L10.5 9.44 5.53 4.47a.75.75 0 00-1.06 1.06l4.97 4.97-4.97 4.97a.75.75 0 101.06 1.06l4.97-4.97 4.97 4.97a.75.75 0 101.06-1.06l-4.97-4.97 4.97-4.97z","fill":"currentColor"}})])
          )
        }
      }
    